module.exports = __webpack_public_path__ + "static/media/puertea.b389a548.jpg";